import script from "./ChiTietXuatTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChiTietXuatTable.vue?vue&type=script&setup=true&lang=ts"

import "./ChiTietXuatTable.vue?vue&type=style&index=0&id=7721d6ba&lang=scss&scoped=true"

import exportComponent from "/var/www/prod/fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7721d6ba"]])

export default __exports__